import React, { useState } from "react";
import { createContact } from "../../../services/contactService";
import { toast } from "react-toastify";

export default function ContactForm() {
    const [form, setForm] = useState({
        fullName: "",
        email: "",
        phone: "",
        message: "",
    });

    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!form.fullName || !form.email || !form.message) {
            toast.warning("Vui lòng nhập đầy đủ họ tên, email và nội dung!");
            return;
        }

        try {
            setLoading(true);
            const res = await createContact(form);
            toast.success(res.data.message || "Gửi liên hệ thành công!");
            setForm({ fullName: "", email: "", phone: "", message: "" });
        } catch (err) {
            toast.error("Lỗi khi gửi liên hệ. Vui lòng thử lại!");
        } finally {
            setLoading(false);
        }
    };

    return (
        <form className="flex flex-col gap-5 " onSubmit={handleSubmit}>
            {["fullName", "email", "phone"].map((field, index) => (
                <div className="flex flex-col" key={index}>
                    <label className="text-slate-200 font-medium mb-1">
                        {field === "fullName"
                            ? "Họ và tên"
                            : field === "email"
                                ? "Email"
                                : "Số điện thoại"}
                    </label>
                    <input
                        type={field === "email" ? "email" : field === "phone" ? "tel" : "text"}
                        name={field}
                        value={form[field]}
                        onChange={handleChange}
                        placeholder={
                            field === "fullName"
                                ? "Nguyễn Văn A"
                                : field === "email"
                                    ? "email@example.com"
                                    : "0123 456 789"
                        }
                        className="border border-[#0e476e] rounded-md px-4 py-2 bg-[#0e3a5e] text-white 
                     placeholder-gray-400 focus:ring-2 focus:ring-[#c9a063] outline-none"
                    />
                </div>
            ))}

            <div className="flex flex-col">
                <label className="text-slate-200 font-medium mb-1">Nội dung</label>
                <textarea
                    name="message"
                    value={form.message}
                    onChange={handleChange}
                    rows={5}
                    placeholder="Viết nội dung bạn cần hỗ trợ..."
                    className="border border-[#0e476e] rounded-md px-4 py-2 bg-[#0e3a5e] text-white 
                   placeholder-gray-400 focus:ring-2 focus:ring-[#c9a063] outline-none resize-none"
                />
            </div>

            <button
                type="submit"
                disabled={loading}
                className="bg-[#c9a063] hover:bg-[#b88a4f] text-[#082f49] py-3 rounded-md font-semibold 
                   transition-all duration-200 shadow-md disabled:opacity-50"
            >
                {loading ? "Đang gửi..." : "Gửi liên hệ"}
            </button>
        </form>
    );
}
